const FacebookIcon = ({ color }: any) => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0 0H30V30H0V0Z' fill='#4867AA' />
      <path
        d='M19.9999 6.66675H17.4999C16.3949 6.66675 15.335 7.10573 14.5536 7.88714C13.7722 8.66854 13.3333 9.72835 13.3333 10.8334V13.3334H10.8333V16.6667H13.3333V23.3334H16.6666V16.6667H19.1666L19.9999 13.3334H16.6666V10.8334C16.6666 10.6124 16.7544 10.4004 16.9107 10.2442C17.0669 10.0879 17.2789 10.0001 17.4999 10.0001H19.9999V6.66675Z'
        fill='white'
      />
    </svg>
  )
}

export default FacebookIcon
